// extracted by mini-css-extract-plugin
module.exports = {"root":"CardPagination_root__1chl9","navigation":"CardPagination_navigation__3n89z","active":"CardPagination_active__1Y4l1"};